<template>
  <v-app style="background: linear-gradient(180deg, #66b5e5 0%, #635ddb 100%);">
    <v-main>
      <FormLogin/>
    </v-main>
  </v-app>
</template>

<script>
import FormLogin from './components/FormLogin';

export default {
  name: 'App',

  components: {
    FormLogin,
  },

  data: () => ({
    //
  }),
};
</script>
